import React, { useState, useEffect } from 'react';
import { Card, Row, Col, message, Input, Button, Table, Modal, Dropdown, Checkbox, Spin } from 'antd';
import { PlusOutlined, SearchOutlined, EditOutlined, DownOutlined } from '@ant-design/icons';
import CommissionForm from './comissionForm'; // Import the CommissionForm component
import axios from 'axios';

const { Search } = Input;

const CommissionList = () => {
  const [modalVisible, setModalVisible] = useState(false);
  const [formData, setFormData] = useState({});
  const [selectedColumns, setSelectedColumns] = useState([]);
  const defaultSelectedColumns = ['name', 'percentage', 'status', 'actions'];
  const [commissionData, setCommissionData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedRow, setSelectedRow] = useState(null);
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    setSelectedColumns(defaultSelectedColumns);
  }, []);

  useEffect(() => {
    fetchData(); // Fetch data when component mounts or form submission occurs
  }, [submitted]);

  const handleAddCommission = () => {
    setFormData({});
    setModalVisible(true);
  };

  const handleRowClick = (record) => {
    setSelectedRow(record);
  };

  const fetchData = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('token'); // Fetch the token from local storage
  
      const response = await axios.get("http://93.127.203.113:5005/commissions", {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
      },
      });
  
      setCommissionData(response.data);
      setFilteredData(response.data);
      setLoading(false);
    } catch (error) {
      message.error("Unable to load data!");
      setLoading(false);
    }
  };
  

  const handleSearch = (value) => {
    setSearchQuery(value);
    const filtered = commissionData.filter(commission =>
      Object.keys(commission).some(key =>
        String(commission[key]).toLowerCase().includes(value.toLowerCase())
      )
    );
    setFilteredData(filtered);
  };

  const handleEditCommission = (record) => {
    setFormData(record);
    setModalVisible(true);
  };

  const commissionColumns = [
    { title: 'Name', dataIndex: 'name', key: 'name' },
    { title: 'Percentage', dataIndex: 'percentage', key: 'percentage' },
    { title: 'Status', dataIndex: 'status', key: 'status' },

    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <Button type="link" icon={<EditOutlined />} onClick={() => handleEditCommission(record)} style={{ marginRight: 8 }}>Edit</Button>
      ),
    },
  ];

  const ColumnSelector = () => (
    <Checkbox.Group
      options={commissionColumns.map(column => ({ label: column.title, value: column.key }))}
      value={selectedColumns}
      onChange={(selected) => setSelectedColumns(selected)}
    />
  );

  const DynamicTable = ({ columns: initialColumns, data, onRow }) => {
    const filteredColumns = initialColumns.filter(column => selectedColumns.includes(column.key));

    return (
      <>
        <Dropdown
          overlay={
            <ColumnSelector />
          }
          trigger={["click"]}
        >
          <Button>
            Select Columns <DownOutlined />
          </Button>
        </Dropdown>
        <div style={{ overflowX: 'auto' }}>
          <Table
            columns={filteredColumns}
            dataSource={data}
            pagination={{ pageSize: 5 }}
            onRow={onRow}
            rowKey="id"
          />
        </div>
      </>
    );
  };

  return (
    <div>
      <Card>
        <Row gutter={[24, 0]}>
          <Col span={12} style={{ textAlign: 'left' }}>
            <Button type="primary" icon={<PlusOutlined />} onClick={handleAddCommission}>
              Add Commission
            </Button>
          </Col>
          <Col span={12}>
            <Search
              placeholder="Search Commissions"
              allowClear
              enterButton={<SearchOutlined />}
              onSearch={handleSearch}
              onChange={e => handleSearch(e.target.value)}
            />
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col xs={24} xl={selectedRow ? 12 : 24}>
            {loading ? (
              <div style={{ textAlign: 'center', marginTop: '20px' }}>
                <Spin size="large" />
              </div>
            ) : (
              <DynamicTable onRow={(record) => ({ onClick: () => handleRowClick(record) })} columns={commissionColumns} data={filteredData} />
            )}
          </Col>
        </Row>
      </Card>

      <Modal
        title={formData.id ? 'Edit Commission' : 'Add Commission'}
        visible={modalVisible}
        onCancel={() => setModalVisible(false)}
        footer={null}
        width={800}
      >
        <CommissionForm formData={formData} setFormData={setFormData} closeModal={() => setModalVisible(false)} setSubmitted={setSubmitted} />
      </Modal>
    </div>
  );
};

export default CommissionList;
